import React, { useState, useEffect, useRef } from "react";
import Box from "ReusableComponents/Box";
import { Grid } from "@mui/material";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";
import { apiClient } from "api/apiClient";

const FeatureSection = ({ small, hiload, currentValue }) => {
  const [data, setData] = useState([]);
  const sectionRef = useRef(null);
  const [selected, setSelected] = useState(1);
  useEffect(() => {
    apiClient.getFeatureStorm(hiload).then((res) => {
      setData(res?.data);
    });
  }, [hiload]);

  const handleFeatureClick = (sectionName, id) => {
    setSelected(id);
    const sectionId = sectionName.toLowerCase();
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setSelected("");
  }, [currentValue]);

  return (
    <Grid
      container
      alignItems="center"
      sx={{
        paddingTop: 0,
      }}
      ref={sectionRef}
    >
      <Grid item xs={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          height="80px"
          bgcolor={COLORS.black}
          borderRadius={SIZES.ten}
          px={2}
          sx={{
            transition: "border-radius 0.3s ease",
          }}
        >
          {data.slice(0, 4).map((item) => (
            <Box
              key={item.id}
              display="flex"
              flex="1"
              padding={small ? "10px" : 0}
              justifyContent="center"
              alignItems="center"
              height="100%"
              bgc={
                selected === item.id
                  ? COLORS.primary
                  : "transparent"
              }
              onClick={() => handleFeatureClick(item.attributes.name, item.id)}
              sx={{
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                padding: "10px",
                textAlign: "center",
              }}
            >
              <img
                src={
                  selected === item.id || currentValue == item?.attributes?.name
                    ? item?.attributes?.image?.data?.attributes?.url || ''
                    : item.attributes.image?.data.attributes.url || ''
                }
                alt={
                  selected === item.id || currentValue == item?.attributes?.name
                    ? item.attributes.image?.data?.attributes?.alternativeText || ''
                    : item.attributes.image?.data?.attributes?.alternativeText || ''
                }
                style={{
                  width: "32px",
                  height: "32px",
                  marginRight: "12px",
                }}
              />
              {!small && (
                <Text
                  fontSize="24px"
                  textColor={
                    selected === item.id || currentValue == item?.attributes?.name
                      ? "black"
                      : COLORS.white
                  }
                  textAlign="center"
                >
                  {item?.attributes?.name}
                </Text>
              )}
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default FeatureSection;
